import { memberBankKey } from "@/queries/members";
import { observedRead, type THintTargets } from "./types";

/** The members domain's hint rows (NG-2797). */
export const MEMBERS_HINTS: THintTargets = {
  // R20, the workspace's member bank, only: an open member picker observing it
  // through `useMemberBank` is re-read. The members table's pages (R21) and
  // role eligibility (R22) are left to their expiry. `flag: null`: the members
  // domain reads only through Query, so the row runs whatever `query-cache` says.
  "members:bank": observedRead(memberBankKey, { flag: null }),
};
